<div class="content-loader-wrap text-center">
  <div class="loading-icon-wrapper">
    <i class="fas fa-circle-notch fa-spin material-icons"></i>
    <!--<i class="fa-spin material-icons material-icons-2x">-->
    <!--donut_large-->
  <!--</i>-->
</div>
@if (showTitle === true) {
  <p class="loading-text" translate>{{title}}</p>
}
@if (secondTitle) {
  <p class="loading-second-text" translate>{{secondTitle}}</p>
}
<p class="sr-only" translate>{{title}}</p>
</div>
